import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { navLinks } from '../const'
import { logo, menu, close } from '../assets'

const Navbar = () => {
    const [active, setActive] = useState('')
    const [toggle, setToggle] = useState(false)

    return (
        <nav className='sm:px-16 px-6 w-full flex items-center py-5 fixed top-0 z-20 bg-primary'>
            <div className='w-full flex justify-between items-center max-w-7xl mx-auto'>
                <Link
                    to='/'
                    className='flex items-center gap-2'
                    onClick={() => {
                        setActive('')
                        window.scrollTo(0, 0)
                    }}
                >
                    <img src={logo} alt='logo' className='w-9 h-9 object-contain' />
                    <p className='text-secondary text-[18px] font-bold flex'>
                        James&nbsp;
                        <span className='md:block hidden'>| 3D Software Engineer</span>
                    </p>
                </Link>
                <ul className='list-none hidden sm:flex flex-row gap-10'>
                    {navLinks.map((nav) => (
                        <li
                            key={nav.id}
                            className={`${
                                active === nav.title ? 'text-white' : 'text-secondary'
                            } hover:text-white text-[18px] font-medium cursor-pointer`}
                            onClick={() => setActive(nav.title)}
                        >
                            <a href={`#${nav.id}`}>{nav.title}</a>
                        </li>
                    ))}
                </ul>
                <div className='sm:hidden flex flex-1 justify-end items-center'>
                    <button
                        type='button'
                        aria-label={toggle ? 'Close menu' : 'Open menu'}
                        className='w-[28px] h-[28px] flex items-center justify-center'
                        onClick={() => setToggle(!toggle)}
                    >
                        <img
                            src={toggle ? close : menu}
                            alt=''
                            className='w-[28px] h-[28px] object-contain'
                        />
                    </button>

                    <div
                        className={`${
                            !toggle ? 'hidden' : 'flex'
                        } p-6 bg-tertiary absolute top-16 right-0 mx-4 my-2 min-w-[140px] z-10 rounded-xl`}
                    >
                        <ul className='list-none flex justify-end items-start flex-1 flex-col gap-4'>
                            {navLinks.map((nav) => (
                                <li
                                    key={nav.id}
                                    className={`font-medium cursor-pointer text-[16px] ${
                                        active === nav.title ? 'text-white' : 'text-secondary'
                                    }`}
                                    onClick={() => {
                                        setToggle(!toggle)
                                        setActive(nav.title)
                                    }}
                                >
                                    <a href={`#${nav.id}`}>{nav.title}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
